import React, { createContext, useContext } from 'react';

interface CurrencyLocale {
  locale: string;
  numberLocale?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}

const CurrencyLocaleContext = createContext<CurrencyLocale | null>(null);

export const useCurrencyLocale = () => {
  const currencyLocale = useContext(CurrencyLocaleContext);
  if (!currencyLocale) {
    throw new Error(
      'useCurrencyLocale must be used within a CurrencyLocaleProvider'
    );
  }
  return currencyLocale;
};

export const CurrencyLocaleProvider = ({ children, value }) => (
  <CurrencyLocaleContext.Provider value={value}>
    {children}
  </CurrencyLocaleContext.Provider>
);
